/* global yaCounter53353294 */

import scrollDepth from 'scroll-depth';
import {router} from './router';

function clearText(text) {
	return text.trim().replace(/\s+/g, ' ');
}

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter53353294) {
		yaCounter53353294.hit(path);
	}
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

let myTimeout = setTimeout(() => {
	return true;
}, 100);

let pixelSrcs = [
	'https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=2865&a.cp=1678&a.ct=d',
	'https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=2865&a.cp=1679&a.ct=d',
	'https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=2865&a.cp=1680&a.ct=d',
	'https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=2865&a.cp=1681&a.ct=d',
	'https://wcm-ru.frontend.weborama.fr/fcgi-bin/dispatch.fcgi?a.A=co&a.si=2865&a.cp=1682&a.ct=d',
];

let percent0 = false;

let percent25 = false;

let percent50 = false;

let percent75 = false;

let percent100 = false;

router.on('enter', (prevState, currentState) => {
	clearTimeout(myTimeout);

	myTimeout = setTimeout(() => {
		start15SecTimeout();

		if (prevState.route && currentState.route) {
			scrollDepth.reset();

			virtualHit(currentState.route.generatePath({
				params: currentState.params,
			}));
		}
	}, 2000);

	percent0 = false;
	percent25 = false;
	percent50 = false;
	percent75 = false;
	percent100 = false;

	$(document).on('scroll', () => {
		if ($(document.documentElement).data('page') === 'artice') {
			if ($(document).scrollTop() > 0 && !percent0) {
				percent0 = true;
				let img = new Image();

				img.src = pixelSrcs[0];
			}

			if ($(document).scrollTop() + innerHeight > $(document).height() * 0.25 && !percent25) {
				percent25 = true;
				let img = new Image();

				img.src = pixelSrcs[1];
			}

			if ($(document).scrollTop() + innerHeight > $(document).height() * 0.5 && !percent50) {
				percent50 = true;
				let img = new Image();

				img.src = pixelSrcs[2];
			}

			if ($(document).scrollTop() + innerHeight > $(document).height() * 0.75 && !percent75) {
				percent75 = true;
				let img = new Image();

				img.src = pixelSrcs[3];
			}

			if ($(document).scrollTop() + innerHeight >= $(document).height() && !percent100) {
				percent100 = true;
				let img = new Image();

				img.src = pixelSrcs[4];
			}
		}
	});
});

$('.header__logo-boss').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.header__logo-rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.header__nav__item').on('click', (e) => {
	let name = clearText($(e.currentTarget).text());

	ga('send', 'event', 'nav', 'item click', name);
});

$('.result__footer__logo').on('click', () => {
	ga('send', 'event', 'client link', 'logo footer');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.main__item').on('click', (e) => {
	let name = clearText($(e.currentTarget).find('.main__item__title').text());

	ga('send', 'event', 'main', 'article click', name);
});

$('.test__option--1').on('click', () => {
	ga('send', 'event', 'test', 'start');
	ga('rbcspec.send', 'event', 'test', 'start');
});

$('.test__option').on('click', (e) => {
	let name = clearText($(e.currentTarget).data('text'));

	let num = $(e.currentTarget).data('option');

	ga('send', 'event', 'test', `question answer ${num}`, name);
});

$(document).on('show-result', () => {
	let $result = $('.page.result').not('.is-hidden');

	let name = clearText($result.data('text'));

	let num = $result.data('result');

	let gendor = $result.data('gendor');

	let result = `${gendor} || ${num} || ${name}`;

	ga('send', 'event', 'test', 'finish', result);
	ga('rbcspec.send', 'event', 'test', 'finish', result);
});

$('.result .result__social__link').on('click', (e) => {
	let $result = $('.page.result').not('.is-hidden');

	let name = $(e.currentTarget).data('social');

	let text = clearText($result.data('text'));

	let num = $result.data('result');

	let gendor = $result.data('gendor');

	let result = `${name} || ${gendor} || ${text} || ${num}`;

	ga('send', 'event', 'share', 'test result share', result);
});

$('.result__more').on('click', () => {
	ga('send', 'event', 'client link', 'tizer test result');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.result .read-more__item').on('click', (e) => {
	let name = clearText($(e.currentTarget).find('.read-more__item__title').text());

	ga('send', 'event', 'test', 'see also', name);
});

$('.article .result__social__link').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'article share', name);
});

$('.article .read-more__item').on('click', (e) => {
	let name = clearText($(e.currentTarget).find('.read-more__item__title').text());

	ga('send', 'event', 'article', 'see also', name);
});

$('.article__banner').on('click', (e) => {
	let name = clearText($(e.currentTarget).find('.article__banner__title').text());

	ga('send', 'event', 'client link', 'banner click', name);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.social__link').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});

$(document).on('scroll', () => {
	if ($(document.documentElement).data('page') === 'article') {
		let $banner = $('.article').not('.is-hidden').find('.article__banner');

		let name = clearText($banner.find('.article__banner__title').text());

		if ($(document).scrollTop() >= $banner.offset().top - innerHeight / 2 && !$banner.hasClass('is-shown')) {
			$banner.addClass('is-shown');
			ga('send', 'event', 'banner', 'show', name, {nonInteraction: true});
		}
	}
});
